<div style="position: relative; width:100%;">
	<ion-input #txt type="text" class="cText" readonly (click)="onClicked()" [formControlName]="controlName" [placeholder]="placeholder"></ion-input>
	<ion-icon name="caret-down" class="cIcon"></ion-icon>
</div>
